// extracted by mini-css-extract-plugin
export default {"root":"FieldPhoneInput_root__HneiS","inputError":"FieldPhoneInput_inputError__ocIQ2"};